
import { Vue, Component, Prop } from 'vue-property-decorator';
import { types } from '../../api_types';
import T from '../../lang';
import * as ui from '../../ui';
import * as time from '../../time';

import omegaup_Markdown from '../Markdown.vue';

@Component({
  components: {
    'omegaup-markdown': omegaup_Markdown,
  },
})
export default class Summary extends Vue {
  @Prop() title!: string;
  @Prop() description!: string;
  @Prop() startTime!: Date;
  @Prop() finishTime!: Date;
  @Prop() scoreboard!: number;
  @Prop() windowLength!: null | number;
  @Prop() admin!: string;
  @Prop({ default: true }) showDeadlines!: boolean;
  @Prop({ default: true }) showRanking!: boolean;
  @Prop({ default: false }) showLogs!: boolean;
  @Prop({ default: () => [] }) logs!: types.ContestProblemChangeLog[];

  T = T;
  ui = ui;
  time = time;

  get duration(): number {
    if (!this.startTime || !this.finishTime) {
      return Infinity;
    }
    return this.finishTime.getTime() - this.startTime.getTime();
  }

  get eventWindowLength(): string {
    if (this.duration === Infinity) {
      return T.wordsUnlimitedDuration;
    }
    if (this.windowLength) {
      // Convert minutes to milliseconds
      return time.formatDelta(this.windowLength * (60 * 1000));
    }
    return time.formatDelta(this.duration);
  }

  get eventDescription(): string {
    return this.description || '';
  }

  formatLogMessage(changeType: string, problemAlias: string): string {
    switch (changeType) {
      case 'added':
        return ui.formatString(T.arenaContestProblemAdded, { problemAlias });
      case 'modified':
        return ui.formatString(T.arenaContestProblemModified, { problemAlias });
      case 'removed':
        return ui.formatString(T.arenaContestProblemRemoved, { problemAlias });
      default:
        return `${changeType}: ${problemAlias}`;
    }
  }
}
